/**
 * Payment Service
 *
 * API calls for payment concepts domain
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type {
  LC_GetConceptosPagoIn,
  LC_GetConceptosPagoListOut,
  ConceptosPagoListResult,
} from './payment.types';
import { mapConceptosPagoListResponse } from './payment.mapper';


export class PaymentService {
  /**
   * Get paginated list of payment concepts generated in a monthly cut
   */
  async listConceptosPago(
    input: LC_GetConceptosPagoIn,
  ): Promise<ApiResponse<ConceptosPagoListResult>> {
    const queryString = buildQueryString({ ...input });
    const endpoint = `${API_CONFIG.ENDPOINTS.PAYMENT.CONCEPTOS_PAGO}${queryString}`;

    const response = await apiClient.get<LC_GetConceptosPagoListOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: false,
        data: null,
        error: response.error,
        status: response.status,
      };
    }

    return {
      success: true,
      data: mapConceptosPagoListResponse(response.data),
      status: response.status,
    };
  }
}

export const paymentService = new PaymentService();
